// Tiny app-wide notification bus: anything can call notifyError(); the
// <Toaster/> mounted in App renders it. No dependency, no context needed.
const listeners = new Set();
let nextId = 1;

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const notify = (message, kind = 'error') => {
  const toast = { id: nextId++, message, kind };
  listeners.forEach((fn) => fn(toast));
};

export const notifyError = (message) => notify(message, 'error');

// Human-readable message from an axios error (DRF {detail}, field errors, …).
export const errorMessage = (err) => {
  const res = err?.response;
  if (!res) return err?.message ? `Network error: ${err.message}` : 'Network error — is the backend reachable?';
  const data = res.data;
  if (typeof data === 'string' && data.trim() && !data.trim().startsWith('<')) return data.slice(0, 300);
  if (data?.detail) return String(data.detail);
  if (data?.error) return String(data.error);
  if (data && typeof data === 'object') {
    const parts = Object.entries(data).slice(0, 3).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(' ') : typeof v === 'object' ? JSON.stringify(v) : v}`);
    if (parts.length) return parts.join(' · ');
  }
  return `Request failed (${res.status})`;
};
